import React from 'react';
import PropTypes from 'prop-types';

const ActivityCard = ({ activity, onAddToCart }) => {
  const { name, description, price, imageUrl, availableQuantity } = activity;
  const isUnavailable = availableQuantity === 0;

  return (
    <div className={`bg-white rounded-lg shadow-md overflow-hidden transition-shadow flex flex-col h-full ${
      isUnavailable ? 'opacity-60' : 'hover:shadow-lg'
    }`}>
      <div className="relative">
        <img 
          src={imageUrl || 'https://images.unsplash.com/photo-1540541338287-41700207dee6?w=600'}
          alt={name}
          className={`w-full h-48 object-cover ${isUnavailable ? 'grayscale' : ''}`}
        />
        {isUnavailable && (
          <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
            <span className="text-white font-semibold text-lg">Fully Funded</span>
          </div>
        )}
      </div>
      <div className="p-4 flex flex-col flex-grow">
        <h3 className="text-xl font-semibold mb-2">{name}</h3>
        <p className="text-gray-600 mb-4 flex-grow">{description}</p>
        
        <div className="mt-auto">
          <div className="mb-4">
            <div className="flex justify-between items-center">
              <div>
                <p className="text-2xl font-bold text-primary">€{price}</p>
                <p className="text-sm text-gray-500">per experience</p>
              </div>
              <div className="text-right">
                <p className={`font-medium ${isUnavailable ? 'text-red-600' : 'text-green-600'}`}>
                  {availableQuantity} available
                </p>
              </div>
            </div>
          </div>

          <button
            onClick={() => onAddToCart(activity)}
            disabled={isUnavailable}
            className={`w-full py-2 rounded-md transition-colors ${
              isUnavailable
                ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                : 'bg-primary text-white hover:bg-primary-dark'
            }`}
          >
            {isUnavailable ? 'Unavailable' : 'Add to Cart'}
          </button>
        </div>
      </div>
    </div>
  );
};

ActivityCard.propTypes = {
  activity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    price: PropTypes.number.isRequired,
    availableQuantity: PropTypes.number.isRequired,
    imageUrl: PropTypes.string,
  }).isRequired,
  onAddToCart: PropTypes.func.isRequired,
};

export default ActivityCard;
